export default __webpack_public_path__ + "locales/cs/SharingPanel.json?hash=16d940a06243c5ae8355f9a571b6a28d";